import { render, staticRenderFns } from "./TodayFacts.vue?vue&type=template&id=48037160&"
import script from "./TodayFacts.vue?vue&type=script&lang=js&"
export * from "./TodayFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports